import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from 'shared';


export class AgGridTenantGroupRoleSettings {

  constructor(private translate: TranslateService, private deleteEnabled: boolean = true) { }

  public agGridTenantGroupRoleSettings = {
    rowModelType: 'infinite' as any,
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: { mode: 'singleRow', checkboxes: false } as any,
    //rowDeselection: true,
    rowHeight: 55,
    cacheBlockSize: 1000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 1,
    columnDefs: [
      // { field: 'name', headerName: "Platform Group Roles", sortable: true, filter: true},
      { field: 'name', headerName: `${this.translate.data["TENANTGROUPROLESCOLUMNHEADER"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["TENANTGROUPROLESACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_edit: 'edit',
          icon_delete: (this.deleteEnabled)?'delete':'',
          icon_view: 'visibility',
          routerLinkEditPlatformGroupRole: (params: ICellRendererParams) => `/admin/manage-tenants/${_.get(params, 'data.id')}/edit-platform-grouprole`
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}